import { Directive, HostListener, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[matTooltip][libHideTooltipOnClick]',
  exportAs: 'libHideTooltipOnClick',
})
export class TooltipClickHideDirective {
  private readonly tooltip = inject(MatTooltip);

  @HostListener('click')
  onClick(): void {
    this.tooltip.hide();
  }
}
